function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M604.05 4.22C326.29 7 152.69 8.73 83.25 9.43C81.01 9.45 79.23 11.29 79.27 13.52C79.29 14.66 79.28 14.2 79.3 15.38C79.34 17.49 81.09 19.16 83.2 19.1C152.65 17.12 326.26 12.16 604.05 4.22Z",
  id: "a26AQFp8Gj",
  className: "svg-line"
}), /*#__PURE__*/React.createElement("path", {
  d: "M604.18 4.42C326.37 5.94 152.75 6.89 83.3 7.27C81.06 7.28 79.24 9.1 79.24 11.34C79.24 12.48 79.24 12.02 79.24 13.2C79.24 15.31 80.97 16.99 83.07 16.94C152.55 15.27 326.25 11.1 604.18 4.42Z",
  id: "h1tJnYPEnF",
  className: "svg-line"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a26AQFp8Gj",
  opacity: 1,
  fill: "#ffffff",
  fillOpacity: 1
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#h1tJnYPEnF",
  opacity: 1,
  fill: "#FF6F61",
  fillOpacity: 1
}))));

var SvgHeaderLine = function SvgHeaderLine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 646 20",
    width: 646,
    height: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeaderLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/header-line.d23c3cf4.svg";
export { ForwardRef as ReactComponent };